import { toast } from "/src/plugins/vue3-toastify.plugin"
import i18n from "/src/plugins/i18n"

export default function useCopyToClipboard() {
    const copyToClipboard = (str: string, message: string) => {
        // Add a slight delay before attempting to copy
        setTimeout(() => {
            navigator.clipboard
                .writeText(str)
                .then(() => {
                    if (message !== "") {
                        toast.success(message)
                    }
                })
                .catch((error) => {
                    toast.error(
                        `${i18n.global.t("notification_tab.copy_failed")}`
                    )
                })
        }, 100)
    }

    return { copyToClipboard }
}
